export default {
  Flowpage_CRM_Clicked_AuthorizeInForm: 'Flowpage_CRM_Clicked_AuthorizeInForm',
  Flowpage_CRM_Clicked_ManagePageAfterGoogleAuth: 'Flowpage_CRM_Clicked_ManagePageAfterGoogleAuth'
}
